import React from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningIcon from '@mui/icons-material/Warning';
import { CardContent, Divider, IconButton, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { TabName } from "../Views/OrderEditor/OrderEditorTabs";
import { IAppCustomer } from "../../Interfaces/Application/IAppCustomer";
import { AppCustomerStipulationDocumentRequirement } from "../../Interfaces/AppCustomerStipulationDocumentRequirement";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { capitalizeFirstLetter } from "@amsanalytics/react-shared-library";
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from "@progress/kendo-react-layout";
import styles from './_invalid-stipulations-card.module.scss';
import { Constants } from "../../utils/constants";

interface InvalidStipulationsCardProps {
  navigate: (tabName: TabName) => void;
  appCustomers: IAppCustomer[];
  appCustomerStipDocRequirements: AppCustomerStipulationDocumentRequirement[];
}

export const InvalidStipulationsCard: React.FC<InvalidStipulationsCardProps> = (props) => {
  const [selectedTab, setSelectedTab] = React.useState<number>(0);
  return (
    <Card className={styles.invalidStipulationsCardContainer}>
      <CardHeader
        avatar={<WarningAmberIcon />}
        title="Stipulations"
        action={
          <IconButton size="small" onClick={() => props.navigate("Stips")}>
            <EditIcon fontSize="small" />
          </IconButton>
        }
      />
      <Divider variant="middle" />
      <CardContent>
        { // , backgroundColor: 'rgb(255, 244, 229)'
          <div style={{ display: "flex", flex: 1, flexDirection: 'column' }}>
            <TabStrip selected={selectedTab} onSelect={(e: TabStripSelectEventArguments) => setSelectedTab(e.selected)}>
            {props.appCustomers.length > 0 && [...props.appCustomers].sort((a, b) => a.customerRoleId?.toUpperCase() === Constants.roleApplicantId ? -1 : 1)
            .map((appCustomer: IAppCustomer, idx: number) => {
              return (
                <TabStripTab key={idx} contentClassName={styles.tabContent}
                  title={`${capitalizeFirstLetter(appCustomer.customer.firstName)} ${capitalizeFirstLetter(appCustomer.customer.lastName)}`}
                >
                    {/* <Typography style={{ display: 'flex', fontSize: 16, fontWeight: 'bold' }}>
                      {capitalizeFirstLetter(appCustomer.customer.firstName)} {capitalizeFirstLetter(appCustomer.customer.lastName)}
                    </Typography> */}
                    <div style={{ display: 'flex', flex: 1, width: '100%', flexDirection: 'column', overflowY: 'auto', padding: '5px' }}>
                    {props.appCustomerStipDocRequirements
                      .filter((stip) => 
                        stip.applicationCustomerId?.toLowerCase() === appCustomer.id?.toLowerCase()
                      ).map((stip: AppCustomerStipulationDocumentRequirement, key: number) => {
                        const stipulation = `${key + 1}. ${stip.displaySummary}`;
                        const stipulationText = stipulation.split(':')[0]?.replace(' (Primary)', '').replace(' (Co-buyer)', '');
                        const stipulationRequirements = stipulation.split(':')[1]?.replace('.', '');
                        return (
                          <div key={key} style={{ marginBottom: "5px", borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)', display: 'flex', flexDirection: 'column' }}>
                            <span style={{fontSize: '14px', fontWeight: 'bold'}}>{`${stipulationText}`}</span>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                              <span style={{ fontSize: '14px' }}>{stipulationRequirements}</span>
                              {stip.numberOfDocumentsRequired > 0 && stip.numberOfDocumentsAccepted >= stip.numberOfDocumentsRequired && (
                                <CheckCircleOutlineIcon style={{paddingLeft: '5px'}} color='success' fontSize="small" />
                              )}
                              {stip.numberOfDocumentsRequired > 0 && stip.numberOfDocumentsAccepted < stip.numberOfDocumentsRequired && (
                                <WarningIcon style={{paddingLeft: '5px'}} color='warning' fontSize="small" />
                              )}
                            </div>
                            {/* <span style={{ fontWeight: 'bold' }}>: {stipulationRequirements}</span>
                            {stip.numberOfDocumentsAccepted >= stip.numberOfDocumentsRequired && (
                              <CheckCircleOutlineIcon color='success' />
                            )} */}
                          </div>
                        );
                      })}
                    </div>
                </TabStripTab>

              )
            })}
            </TabStrip>
          </div>
        }
      </CardContent>
    </Card>
  );
}